import { z } from 'zod';
import { validatePhone } from '../../../../shared/utils';

export const Schema = z
    .object({
        email: z.string().email(),
        firstName: z.string().min(1, { message: 'Required' }),
        lastName: z.string().min(1, { message: 'Required' }),
        phone: z.string().refine((val) => validatePhone(val), {
            message: 'Invalid phone number',
        }),
        role: z.enum(['user', 'admin', 'teamAdmin', 'viewOnlyUser']),
        isActive: z.boolean(),
        department: z
            .object({ id: z.number().nullable().optional() })
            .nullable()
            .transform((data) => (data?.id ? data : null)),
        vehiclePlate: z.string(),
    })
    .superRefine((val, ctx) => {
        if (val.role === 'teamAdmin' && !val.department?.id) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['department.id'],
                message: 'Required',
            });
        }
    });

export const EditSchema = Schema.and(
    z.object({
        profilePicture: z
            .object({
                id: z.string().uuid(),
            })
            .optional(),
    }),
);
